// 实验4：上次登录标记（优化）
// https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/HXFtYvbMQj/VZolX2m-G0/AmdYxcd-Mx-k-U
export function runTest() {
    $('#TANGRAM__PSP_4__smsSubmit').attr('value', '登录/注册');
}
